export abstract class ChartDirectiveBase {
    restrict = 'E';
    scope: any;
    replace = true;
    template = '<div style="height: 100%; width: 100%;"><svg></svg></div>';
}